
import React, { Component } from 'react';
import { Modal, Row, Divider, Button, Table, Tooltip, Tag, Descriptions } from 'antd';

import Image from '../../ui/Image';

import './AuctionStyle.css';

const fields = [{
    "text": "场次名称",
    "field": "name",
}, {
    "text": "竞价开始时间",
    "field": "startTime",
}, {
    "text": "展示时间",
    "field": "startShowTime",
}, {
    "text": "流拍时长",
    "field": "abortiveDuration",
}, {
    "text": "加价倒计时",
    "field": "increaseDuration",
}, {
    "text": "竞价间隔/秒",
    "field": "intervalDuration",
}, {
    "text": "看车地点",
    "field": "viewAddr",
}, {
    "text": "是否激活",
    "field": "state",
    format: { 0: '激活', 1: '删除', 2: '停止' }
}, {
    "text": "状态",
    "field": "status",
    format: { 0: '未开始', 1: '进行中', 2: '已结束' }
}, {
    "text": "图片",
    "field": "image",
    image: true
}];


class AuctionSessionDetail extends Component {

    columns = [{
        title: '竞价品名称',
        dataIndex: 'name',
        width: 300,
        fixed: 'left',
        "className": "lots-table-td",
    }, {
        title: '竞价品编号',
        dataIndex: 'code',
        width: 150,
    }, {
        title: '车辆信息',
        dataIndex: 'vehicleIdsStr',
        width: 400,
        render: (text, record, index) => {
            if (text != null && text.length > 0) {
                text = text.replaceAll(",", "\n");
            }
            return (<Tooltip title={text}>
                <pre style={{ margin: "0px", overflow:'visible' }}>{text}</pre>
            </Tooltip>)
        }
    }, {
        title: '起始价',
        dataIndex: 'startPrice',
        width: 100,
    }, {
        title: '保留价',
        dataIndex: 'reservePrice',
        width: 100,
    }, {
        title: '保证金',
        dataIndex: 'bond',
        width: 100,
    }, {
        title: '加价方式',
        dataIndex: 'offerDictStr',
        width: 400,
        render: (text, record, index) => {
            let tags = text == null || text === "" ? [] : text.split(",");
            return (<span>
                {tags.map(tag => {
                    return <Tag color="#108ee9" key={tag}>{tag}</Tag>
                })}
            </span>)
        }
    }, {
        title: '其他费用',
        dataIndex: 'serviceChargeDictStr',
        width: 400,
        render: (text, record, index) => {
            let tags = text == null || text === "" ? [] : text.split(",");
            return (<span>
                {tags.map(tag => {
                    return <Tag color="#108ee9" key={tag}>{tag}</Tag>
                })}
            </span>)
        }
    }, {
        title: '展示出价人',
        dataIndex: 'showBidder',
        width: 120,
        render: (text, record, index) => (
            text === 1 ? '是' : '否'
        )
    }, {
        title: '顺序号',
        dataIndex: 'sequence',
        width: 100,
    }, {
        title: '开始时间',
        dataIndex: 'startTime',
        width: 200,
    }, {
        title: '结束时间',
        dataIndex: 'endTime',
        width: 200,
    }, {
        title: '获胜会员',
        dataIndex: 'memberName',
        width: 150,
    }, {
        title: '最终价格',
        dataIndex: 'finalPrice',
        width: 150,
    }, {
        title: '竞价结果',
        dataIndex: 'status',
        width: 130,
        fixed: 'right',
        render: (text, record, index) => (
            text === 0 ? '无人出价' : text === 1 ? '成功' : text === 2 ? '低于保留价' : text === 3 ? '竞价成功，但没有成交' : ''
        )
    // }, {
    //     title: '操作',
    //     dataIndex: 'id',
    //     width: 120,
    //     fixed: 'right',
    //     render: (text, record, index) => (
    //         <div>
    //             {
    //                 record.status === 1 || record.status === 2 ?
    //                     <Tooltip title="出价记录详细">
    //                         <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
    //                     </Tooltip> : ""
    //             }

    //         </div>
    //     )
    }];

    state = {
        imageUrl: null,
        image: null,

        lotsList: [],

        recordList: [],
        visible: false
    }

    initData = (editData, lotsList) => {
        let image = editData.image;
        if (image != null && image !== "") {
            image = "data:image/jpeg;base64," + image.replace(/\r\n/g, "");
        }
        this.setState({ image: image, imageUrl: editData.imageUrl, lotsList: lotsList });
    }

    // detail = (info, e) => {
    //     http.get({
    //         url: '/auctionSession/findBidRecord',
    //         data: {
    //             lotsId: info.id
    //         },
    //         success: (res) => {
    //             this.setState({ recordList: res == null ? [] : res, visible: true });
    //         }
    //     });
    // }

    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={1100}
                visible={visible}
                title="场次信息详细"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null, lotsList: [] }); }}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions title="" bordered>
                    {fields.map((item, index) => {
                        let val = editData[item.field]
                        if (item.format) {
                            val = item.format[val];
                        }
                        if (item.image) {
                            val = <Image
                                onlyView={true}
                                file={this.state.image}
                                text={item.text}
                                url={this.state.imageUrl}
                            />
                        }
                        return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>
                    })}
                </Descriptions>
                <Row>
                    <Divider orientation="left">竞价品列表</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.state.lotsList}
                        pagination={false}
                        bordered={true}
                        scroll={{ x: true }}
                    />
                </Row>
                {/* <AuctionBidRecord
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false }) }}
                    recordList={this.state.recordList}
                /> */}
            </Modal>
        );
    }
}


export default AuctionSessionDetail;